import(/* webpackMode: "eager" */ "/vercel/path0/src/app/public-profile/[userId]/publicProfile.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/public-profile/[userId]/PublicProfilePageClient.js");
